module.exports = __webpack_public_path__ + "assets/974e81eaeec6f4b1a46f35e4fbe2b9bf.png";